import React from 'react'
import { BottomNavigationContainer } from './components/bottom-container'
import { BottomNavigationItem } from './components/bottom-item'
import { useBottomNavigation } from './hooks'
import type {
  IBottomNavigationContainerProps,
  IBottomNavigationItemProps,
} from './types/index'

const BottomNavigationRoot = ({
  children,
}: IBottomNavigationContainerProps) => {
  const { MenuItems } = useBottomNavigation()
  const renderInternalComponents = (children: React.ReactNode) => {
    const components = React.Children.map(children, child => {
      if (React.isValidElement(child) && child.type === BottomNavigationItem) {
        const item = MenuItems.find(
          menuItem => menuItem.index === child.props.index
        )
        return React.cloneElement(child, { ...child.props, ...item })
      }
    })

    // biome-ignore lint/suspicious/noExplicitAny:
    return components?.sort((a: any, b: any) => a.props.index - b.props.index)
  }

  return (
    <BottomNavigationContainer>
      {renderInternalComponents(children)}
    </BottomNavigationContainer>
  )
}

BottomNavigationRoot.displayName = 'BottomNavigation'

export const BottomNavigation = {
  Root: BottomNavigationRoot,
  Item: BottomNavigationItem,
}

export type { IBottomNavigationItemProps }
